<template>
  <div class="subscription-content">
    <header>
      <h2>
        {{ subscribedInformations.getOffer().getLabel() }}
      </h2>
    </header>
    <article>
      <div>
        <OfferInformationComponent :subscribed-informations="subscribedInformations" />
      </div>
      <div class="subscribed-selling-points q-mt-lg">
        <SellingPointsList
          :selling-points="subscribedInformations.getOffer().getDescription()"
          :picture="subscribedInformations.getOffer().getImg()"
        />
      </div>
    </article>
    <footer>
      <div v-for="(btn, index) in subscribedInformations.getOffer().getActionButtons()" :key="index" class="text-center q-my-md">
        <QBtn
          class="btn-navigation btn-large"
          :class="btn.isNotOkBtn() ? 'text-underline' : ''"
          no-caps
          :flat="btn.isNotOkBtn()"
          :color="btn.isOkBtn() ? 'secondary' : ''"
          :label="btn.getLabel()"
          @click="buttonAction(btn)"
        />
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p class="text-subtitle2 margin-0" v-html="subtitle" />
    </footer>
  </div>
</template>

<script>
  import { ACTION_SUBSCRIBED_GET_INFORMATIONS, GETTER_SUBSCRIBED_GET_INFORMATIONS } from "@etab/stores/types";
  import { useSubscriptionStore } from "@etab/stores/subscription";
  import { mapStores } from "pinia";
  import { ETAB_ROUTES } from "@etab/config";
  import { typeformMixins } from "@core/mixins/typeform.mixins";
  import { NotificationsManager } from "@core/managers/notifications.manager";

  import SellingPointsList from "@etab/components/subscription/SellingPointsList.component.vue";
  import OfferInformationComponent from "@etab/components/subscription/OfferInformation.component.vue";

  export default {
    components: {
      SellingPointsList,
      OfferInformationComponent,
    },
    mixins: [typeformMixins],
    computed: {
      ...mapStores(useSubscriptionStore),
      subscribedInformations() {
        return this.subscriptionStore[GETTER_SUBSCRIBED_GET_INFORMATIONS];
      },
      subtitle() {
        if (this.subscribedInformations.getFormattedEndDate()) {
          return this.$t("ETAB.PAGES.SUBSCRIPTION.@FOOTER_SUBSCRIBED_WITH_ENGAGEMENT_SUBTITLE", {
            endDate: this.subscribedInformations.getFormattedEndDate(),
          });
        }
        return this.$t("ETAB.PAGES.SUBSCRIPTION.@FOOTER_SUBSCRIBED_WITHOUT_ENGAGEMENT_SUBTITLE", {
          date: this.subscribedInformations.getFormattedNextPaymentDate(),
        });
      },
    },
    created() {
      this.initSubscribedInformations();
    },
    methods: {
      async initSubscribedInformations() {
        try {
          this.$_startGlobalLoading();
          await this.subscriptionStore[ACTION_SUBSCRIBED_GET_INFORMATIONS]();
        } catch (error) {
          NotificationsManager.error({ message: "ERRORS.@SOMETHING_WENT_WRONG" });
          this.$router.push({ name: ETAB_ROUTES.userMenu.root.name }).catch((suppressedError) => {});
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      },
      buttonAction(btn) {
        if (btn.isOkBtn()) {
          this.$router.push({ name: ETAB_ROUTES.creation.root.name }).catch((suppressedError) => {});
        } else {
          this.$_typeformOpenPopup(btn.getLink());
        }
      },
    },
  };
</script>
